module.exports = __webpack_public_path__ + "media/application/images/svgs/logo-pawnbroker-3e1f16d9900ceb34fda46d465e9feb90.svg";